import { render, staticRenderFns } from "./OTPForm.vue?vue&type=template&id=79e89445&scoped=true&"
import script from "./OTPForm.vue?vue&type=script&lang=js&"
export * from "./OTPForm.vue?vue&type=script&lang=js&"
import style0 from "./OTPForm.vue?vue&type=style&index=0&id=79e89445&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e89445",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VBtn,VCardActions,VCardText,VForm})
